import {
  PC_BANG_NOTICE_BY_ID_REQUEST,
  PC_BANG_NOTICE_BY_ID_RESPONSE,
  PC_BANG_NOTICES_REQUEST,
  PC_BANG_NOTICES_RESPONSE,
} from '../actions/notices.actions';

export default function notices(state = {data: [], page: undefined, totalCount: 0, selectedNotice: {}}, action) {
  switch (action.type) {
    case PC_BANG_NOTICES_REQUEST: {
      return state;
    }
    case PC_BANG_NOTICES_RESPONSE: {
      let nextState = {...state};
      if (action.notices && action.notices.length > 0) {
        nextState = [];
        nextState.data = action.notices;
        nextState.page = action.page;
        nextState.totalCount = action.totalCount;
      }
      return nextState;
    }

    case PC_BANG_NOTICE_BY_ID_REQUEST: {
      let nextState = {...state};
      nextState.selectedNotice = {};
      return nextState;
    }

    case PC_BANG_NOTICE_BY_ID_RESPONSE: {
      let nextState = {...state};
      nextState.selectedNotice = action.notice;
      return nextState;
    }
  }
  return state;
}
